import { Component, Input } from "@angular/core";

@Component(
    {
        selector: 'hhsg-message-bar',
        templateUrl: 'message-bar.component.html',
        styleUrls: ['message-bar.component.scss']
    }
)

export class HhsgSharedMessageBarComponent {
    @Input() isError = false;
    @Input() 
    set yOffset(yOffset : number) {
        if (yOffset) {
            this.yOffsetValue = yOffset;
        } else {
            this.yOffsetValue = this.defaultYOffset;
        }
    }
    get yOffset() : number {
        return this.yOffsetValue ?? this.defaultYOffset; 
    }

    @Input()  //In seconds
    set visibilityTimeout(visibilityTimeout: number) {
        // If the timeout is 0 (meaning don't time out), display the message for an hour.
        if (visibilityTimeout == 0) {
            visibilityTimeout = 3600;
        }
        // Convert to miliseconds
        this.displayTime = visibilityTimeout * 1000;
    }
    get visibilityTimeout() : number {
        return this.displayTime / 1000;
    }

    @Input()
    set messages(messages: string[]) {
        this.allMessages = messages;
        let messageString = "";
        if (messages) {
            messages.forEach((message) => { messageString += message + "\n"});   
        }
        this.message = messageString.trim();     
        this.isVisible = messages?.length > 0;
      }
    
    get messages(): string[] {
        return this.allMessages;
    }

    
    message: string;
    isVisible: boolean = false;
    displayTime: number;

    private yOffsetValue: number;
    private allMessages: string[];
    private defaultYOffset = 135;
}
